import React from "react";
import { Formik } from "formik";
import { Col, Form, Button } from "react-bootstrap";
import "./forgot-password.scss";
import { ResetPasswordTokenVerify, ResetPassword } from "../../api";
import Loader from "../loader/loader";
import { Link } from "react-router-dom";
import { createBrowserHistory } from "history";
import * as yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const schema = yup.object({
    email: yup
        .string()
        .trim()
        .email("* The Email Must Be A Valid Email Address.")
        .required("* Email-Address is Required"),
    password: yup
        .string()
        .trim()
        .required("* Password Is Required")
        .min(14, "Password must be at least 14 characters.")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter.")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter.")
        .matches(/[0-9]/, "Password must contain at least one number.")
        .matches(/[\-!@#$%^&*()_+\[\]{}|;:,.<>?]/, "Password must contain at least one special character."),
    password_confirmation: yup
        .string()
        .trim()
        .required("* Confirm Password Is Required")
        .min(14, "Password must be at least 14 characters.")
        .oneOf(
            [yup.ref("password"), null],
            "The Password confirmation does not match.",
        ),
});
class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_submitted: false,
            show_spinner: false,
            show_login_link: false,
            errorMessage: "",
            formData: {
                email: "",
                password: "",
                password_confirmation: "",
            },
            errors: [],
            disableResetBtn: false,
            passwordVisible: false,
            confirmPasswordVisible: false,
        };
    }
    componentDidMount() {
        const postData = {
            token: this.props.match.params.token,
        };
        ResetPasswordTokenVerify(postData).then((res) => {
            if (res.status === 200) {
                let formData = this.state.formData;
                formData["email"] = res.data.email;
                this.setState({ formData: formData });
            } else {
                setTimeout(function () {
                    const history = createBrowserHistory({
                        forceRefresh: true,
                    });
                    history.push("/");
                }, 1000);
            }
        });
    }
    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    handleChangePassword(evt) {
        this.setState({ show_spinner: true });

        const fromData = this.state.formData;

        const postData = {
            token: this.props.match.params.token,
            email: fromData.email,
            password: fromData.password,
            password_confirmation: fromData.password_confirmation,
        };
        ResetPassword(postData).then((res) => {
            if (res.status === 200) {
                this.setState({ show_spinner: false });
                this.setState({
                    show_login_link: true,
                    errorMessage: "Password Reset Successfully.",
                });
                this.props.history.push("/");
            } else {
                this.setState({ show_spinner: false });
                this.setState({ errorMessage: res.message });
            }
        });
    }

    togglePasswordVisibility = () => {
        this.setState({ passwordVisible: !this.state.passwordVisible });
    };

    toggleConfirmPasswordVisibility = () => {
        this.setState({
            confirmPasswordVisible: !this.state.confirmPasswordVisible,
        });
    };

    render() {
        const {
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
            show_login_link,
            disableResetBtn,
            passwordVisible,
            confirmPasswordVisible,
        } = this.state;
        return (
            <div>
                <div className="reset-password">
                    <div className="Login-header">
                        <h1>STRATUS</h1>
                    </div>
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleChangePassword(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="add-template-form"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <div className="from-heading">
                                    <h2>STRATUS | Reset Password</h2>
                                </div>
                                <Form.Row className="floating-form">
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3 position-relative"
                                    >
                                        <Form.Control
                                            placeholder="Email"
                                            type="text"
                                            name="email"
                                            value={
                                                values.email ? values.email : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.email && !!errors.email
                                            }
                                            isValid={
                                                is_submitted && !errors.email
                                            }
                                            className="preapp-form-input"
                                            disabled
                                        />
                                        <Form.Label className="floating-label">
                                            Email
                                        </Form.Label>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.email}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Password"
                                            type={
                                                passwordVisible
                                                    ? "text"
                                                    : "password"
                                            }
                                            name="password"
                                            value={
                                                values.password
                                                    ? values.password
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.password &&
                                                !!errors.password
                                            }
                                            isValid={
                                                is_submitted && !errors.password
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Label className="floating-label">
                                            Password
                                        </Form.Label>
                                        <div className="eye-icon">
                                            <FontAwesomeIcon
                                                icon={
                                                    passwordVisible
                                                        ? faEyeSlash
                                                        : faEye
                                                }
                                                className="password-icon"
                                                onClick={
                                                    this
                                                        .togglePasswordVisibility
                                                }
                                            />
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.password}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <Form.Control
                                            placeholder="Confirm Password"
                                            type={
                                                confirmPasswordVisible
                                                    ? "text"
                                                    : "password"
                                            }
                                            name="password_confirmation"
                                            value={
                                                values.password_confirmation
                                                    ? values.password_confirmation
                                                    : ""
                                            }
                                            onChange={handleChange}
                                            isInvalid={
                                                touched.password_confirmation &&
                                                !!errors.password_confirmation
                                            }
                                            isValid={
                                                is_submitted &&
                                                !errors.password_confirmation
                                            }
                                            className="preapp-form-input"
                                        />
                                        <Form.Label className="floating-label">
                                            Confirm Password
                                        </Form.Label>
                                        <div className="eye-icon">
                                            <FontAwesomeIcon
                                                icon={
                                                    confirmPasswordVisible
                                                        ? faEyeSlash
                                                        : faEye
                                                }
                                                className="password-icon"
                                                onClick={
                                                    this
                                                        .toggleConfirmPasswordVisibility
                                                }
                                            />
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.password_confirmation}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Form.Row>
                                <p className="error-message">{errorMessage}</p>
                                <Button
                                    size="lg"
                                    form="add-template-form"
                                    type="submit"
                                    disabled={disableResetBtn}
                                >
                                    Reset Password
                                </Button>
                                {show_login_link ? (
                                    <Link to="/" className="login-button">
                                        Login
                                    </Link>
                                ) : (
                                    ""
                                )}
                            </Form>
                        )}
                    </Formik>
                    <div className="copy-right">
                        <p>Copyright © PaymentCloud. All Rights Reserved.</p>
                    </div>

                    {show_spinner ? (
                        <div className="spinner">
                            <Loader />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                <div className="background-div">
                    <img
                        src="/images/dot_bg.png"
                        alt="background"
                        className="background"
                    />
                </div>
            </div>
        );
    }
}

export default ChangePassword;
